export const API_URL = "https://api.trackento.com";
export const WS_URL = "wss://api.trackento.com/ws";
